import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { MediaAsset } from '../../../shared/api'
import { upload } from '../../../shared/api'

export function useUploadAsset() {
  const qc = useQueryClient()

  return useMutation({
    mutationFn: ({
      file,
      altText,
      onProgress,
    }: {
      file: File
      altText?: string
      onProgress?: (f: number) => void
    }) => {
      const form = new FormData()

      if (altText) form.append('altText', altText)
      form.append('file', file)

      return upload<MediaAsset>('/media/assets', form, onProgress)
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['media'] }),
  })
}
